<h1 mat-dialog-title>EDR Info and RealData</h1>
<mat-divider></mat-divider>
<mat-dialog-content>
  <div *ngIf="edrinfo">
    <h3>Transfer ID</h3>
    <textarea rows="1">{{ id }}</textarea>
    <h3>Endpoint</h3>
    <textarea rows="2">{{ edrinfo.optionalValue('edc','endpoint') }}</textarea>
    <h3>Authorization</h3>
    <textarea rows="7">{{ edrinfo.optionalValue('edc','authorization') }}</textarea>
    <h3>AuthType</h3>
    <div>{{ edrinfo.optionalValue('edc','authType')  }}</div>
  </div>
  <div *ngIf="realData">
    <h3>RealData</h3>
    <textarea class="realData">{{ realData }}</textarea>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
    <div *ngIf="edrinfo">
      <button (click)="onDowndload()" color="accent" mat-stroked-button>
        <mat-icon>save</mat-icon> Downdload
      </button>
    </div>
    <button color="accent" mat-dialog-close mat-stroked-button>
        <mat-icon>cancel</mat-icon> Cancel
    </button>
</mat-dialog-actions>
